import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Sparkles, Gamepad2 } from 'lucide-react';

const Index = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950 flex flex-col">
      {/* Hero Section */}
      <div className="flex-1 flex flex-col items-center justify-center px-4 text-center">
        <Button
          onClick={() => navigate('/game')}
          className="bg-gradient-to-r from-cyan-500 to-purple-500 hover:from-cyan-600 hover:to-purple-600 text-white font-bold text-lg py-7 px-10 rounded-lg transition-all transform hover:scale-105"
        >
          <Gamepad2 className="w-6 h-6 mr-2" />
          Enter Arena
        </Button>
      </div>

      {/* Footer */}
      <footer className="border-t border-slate-800 py-6 px-4 text-center text-slate-400 text-sm">
        <p>Choose your fighters and dominate the battle arena</p>
      </footer>
    </div>
  );
};

export default Index;